import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FooterAbstracClassComponent } from '@app/footer/shared/footer-abstrac-class.component';
import { RowHeaderComponent } from '../../shared/row-header/row-header.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-social',
    templateUrl: './social.component.html',
    styleUrls: ['./social.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RowHeaderComponent, TranslatePipe],
})
export class SocialComponent extends FooterAbstracClassComponent {}
